import customerProfile from '@/api/customer-profile'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  customer_types: [],
  customer_zones: [],
  service_types: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,

  SET_CUSTOMER_TYPES(state, customer_types) {
    state.customer_types = customer_types
  },

  SET_CUSTOMER_ZONES(state, customer_zones) {
    state.customer_zones = customer_zones
  },

  SET_SERVICE_TYPES(state, service_types) {
    state.service_types = service_types
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return customerProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return customerProfile.store(data)
  },

  async find(context, id) {
    return await customerProfile.find(id)
  },

  update(context, data) {
    return customerProfile.update(data)
  },

  destroy(context, id) {
    return customerProfile.destroy(id)
  },

  async dataBeforeCreate({ commit, state }) {
    if (!state.customer_types.length > 0) {
      let response = await customerProfile.getcustomertype()
      commit('SET_CUSTOMER_TYPES', response)
    }
    if (!state.customer_zones.length > 0) {
      let response = await customerProfile.getcustomerzone()
      commit('SET_CUSTOMER_ZONES', response)
    }
    if (!state.service_types.length > 0) {
      let response = await customerProfile.getservicetype()
      commit('SET_SERVICE_TYPES', response)
    }
  }
}
